import anime from 'animejs'
import BaseController from '@/core/controller/BaseController'

/**
 *
 */
class JSScrollController extends BaseController {
  //
  public offsetY = 0

  /**
   * コンストラクタ
   *
   */
  constructor() {
    super()
  }

  /**
   *
   */
  public to(scrollY: number, duration = 700): void {
    anime({
      targets: 'html,body',
      scrollTop: scrollY,
      duration: duration,
      easing: 'easeInOutCirc',
    })
  }

  /**
   * 実行
   */
  public run(elem: HTMLElement, center = false, duration = 700): void {
    const rect = elem.getBoundingClientRect()
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    let scrollY = rect.top + scrollTop

    // 縦センターにする
    if (center) {
      const winHeight = document.documentElement.clientHeight
      if (winHeight - this.offsetY > rect.height) {
        scrollY -= (winHeight - rect.height) / 2
      }
    }

    scrollY -= this.offsetY

    anime({
      targets: 'html,body',
      scrollTop: scrollY,
      duration: duration,
      easing: 'easeOut',
    })
  }

  /**
   * 実行
   */
  public skipRun(elem: HTMLElement, center = false, duration = 700): void {
    const rect = elem.getBoundingClientRect()
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    let scrollY = rect.top + scrollTop
    const winHeight = document.documentElement.clientHeight

    // 縦センターにする
    if (center) {
      if (winHeight - this.offsetY > rect.height) {
        scrollY -= (winHeight - rect.height) / 2
      }
    }

    scrollY -= this.offsetY
    scrollY -= winHeight / 10

    if (scrollY < winHeight / 2) return

    anime({
      targets: 'html,body',
      scrollTop: scrollY,
      duration: 0,
    })

    setTimeout(() => {
      this.run(elem, center, duration)
    }, 100)
  }
}

export default JSScrollController
